<!-- <div #dialog> -->
  <!-- Modal Header -->
  <ng-container>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <header class="cx-dialog-header modal-header saved-cart-modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'savedCart.restoreCart' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </header>
        <form [formGroup]="restoreSavedCartForm">
          <!-- Modal Body -->
          <div class="vs-dialog-body modal-body saved-cart-modal-body">
            <p class="dialog-hint">
              {{ 'savedCart.restoreDialogHint' | cxTranslate }}
            </p>
            <div
              *ngIf="currentCart.restoredUserName != ''"
              class="text-warning shared-cart-warning"
            >
              <span class="material-icons warning-icon">warning </span>
              <span class="warning-text"
                >{{
                  'savedCart.sharedCartText'
                    | cxTranslate : { name: currentCart?.restoredUserName }
                }}
                {{ currentCart?.restoredTime }}</span
              >
            </div>
            <table>
              <tr>
                <th>{{ 'savedCart.cartName' | cxTranslate }}</th>
                <th>{{ 'savedCart.id' | cxTranslate }}</th>
                <th>{{ 'savedCart.totalLine' | cxTranslate }}</th>
              </tr>
              <tr>
                <td>{{ currentCart.name }}</td>
                <td>{{ currentCart.code }}</td>
                <td>{{ currentCart.totalItems }}</td>
              </tr>
            </table>
            <div class="form-group">
              <div
                *ngIf="sharedCartFlag == 'false'"
                class="form-control-wrapper keep-copy-block"
              >
                <div class="vs-checkbox">
                  <input
                    id="restoreKeepCopy"
                    name="keepCopy"
                    type="checkbox"
                    value="false"
                    [(ngModel)]="keepCopy"
                    formControlName="keepCopy"
                  />

                  <label for="restoreKeepCopy" class="keep-copy-label">
                    {{ 'savedCart.keepCopy' | cxTranslate }}
                  </label>
                </div>
              </div>
              <div
                *ngIf="activeCartSize"
                class="form-control-wrapper current-item-block"
              >
                <label>
                  <span class="label-content required">{{
                    'savedCart.saveCartAsName' | cxTranslate
                  }}</span>
                  <input
                    type="text"
                    name="saveCartAsName"
                    formControlName="saveCartAsName"
                    maxlength="200"
                    [(ngModel)]="saveCartAsName"
                    [readonly]="checkboxStatus"
                    #saveCartAsNameEl
                  />
                  <span class="errorMessage create-saved-cart-name-error">{{
                    duplicateErrorMessage
                  }}</span>
                </label>
                <span
                  *ngIf="nameError"
                  class="errorMessage create-saved-cart-name-error"
                  >{{ 'savedCart.restoreError' | cxTranslate }}</span
                >
              </div>
              <div
                *ngIf="activeCartSize"
                class="form-control-wrapper keep-copy-block"
              >
                <div class="vs-checkbox">
                  <input
                    id="restoreDontSaveForLater"
                    name="dontSaveForLater"
                    type="checkbox"
                    value="false"
                    [(ngModel)]="dontSaveForLater"
                    (click)="check_en($event)"
                    formControlName="dontSaveForLater"
                  />
                  <label for="restoreDontSaveForLater" class="keep-copy-label">
                    {{ 'savedCart.restoreSaveItem' | cxTranslate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <footer class="modal-footer saved-cart-modal-footer">
            <!-- Actions -->
            <div class="vs-modal-buttons">
              <button
                class="btn vs-text-btn btnClass cancleBtnClass"
                (click)="dismissModal('Cross click')"
              >
                {{ 'savedCart.cancel' | cxTranslate }}
              </button>
              <button class="btn vs-primary-btn btnClass" (click)="onSubmit()">
                {{ 'savedCart.restore' | cxTranslate }}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>
  </ng-container>
<!-- </div> -->
